import React, { useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import StarIcon from "@material-ui/icons/StarBorder";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CheckIcon from "@material-ui/icons/Check";
import { tiers } from "constants";

const useStyles = makeStyles((theme) => ({
  "@global": {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
  },

  card: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    // [theme.breakpoints.up("md")]: {
    //   width: "300px",
    // },
    // [theme.breakpoints.up("lg")]: {
    //   width: "250px",
    // },
    cursor: "pointer",
  },
  selectedCard: {
    border: "3px solid #465362",
    cursor: "pointer",
  },

  cardHeader: {
    whiteSpace: "pre-wrap",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700],
  },
  popularCardHeader: {
    whiteSpace: "pre-wrap",
    backgroundColor: "#FD6D53",
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    // marginBottom: theme.spacing(2),
  },
  annualCardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
  },
  textCenter: {
    textAlign: "center",
    // marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: "1.5rem",
    display: "inline-block",
    width: "24px",
    height: "24px",
    backgroundColor: "#465362",
    color: "#89d2d3",
    borderRadius: "50%",
    padding: "4px",
    boxSizing: "content-box",
    marginRight: "11px",
    marginTop: "-2px",
  },
}));

export default function PricingView(props) {
  const classes = useStyles();
  const { showActions, setPlan, plan } = props;
  const [selected, setSelected] = useState(plan);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="xl" component="main">
        <Grid
          container
          spacing={4}
          alignItems={showActions ? "flex-start" : "flex-start"}
        >
          {tiers.map((tier) => (
            <Grid item key={tier.price} xs="12" md="4" sm="6" lg="3">
              <Card
                raised={true}
                className={
                  showActions && selected === tier
                    ? classes.selectedCard
                    : classes.card
                }
                onClick={() => {
                  setSelected(tier);
                  setPlan(tier);
                }}
              >
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: "center" }}
                  subheaderTypographyProps={{ align: "center" }}
                  action={tier.title === "Annual" ? <StarIcon /> : null}
                  className={
                    tier.title === "Annual"
                      ? classes.popularCardHeader
                      : classes.cardHeader
                  }
                />
                <CardContent>
                  <div
                    className={
                      tier.title === "Annual"
                        ? classes.annualCardPricing
                        : classes.cardPricing
                    }
                  >
                    <Typography component="h3" variant="h4" color="textPrimary">
                      ${tier.price}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                      {tier.title === "Annual" ? "/mo" : "/mo"}
                    </Typography>
                  </div>
                  {tier.title === "Annual" ? (
                    <Typography
                      variant="h6"
                      color="textSecondary"
                      className={classes.textCenter}
                    >
                      ($359.88 annually)
                    </Typography>
                  ) : null}

                  <div style={{ textAlign: "center" }}>
                    <Typography variant="subtitle2" color="textSecondary">
                      &
                    </Typography>
                  </div>

                  <div
                    className={
                      tier.title === "Annual"
                        ? classes.annualCardPricing
                        : classes.cardPricing
                    }
                  >
                    <Typography variant="subtitle1" color="textSecondary">
                      {tier.title != "Premium"
                        ? "10% Revenue share"
                        : "0% Revenue share"}
                    </Typography>
                  </div>
                  <ul>
                    {tier.description.map((line) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "16px",
                        }}
                      >
                        <CheckIcon className={classes.icon} />
                        <Typography
                          component="li"
                          variant="subtitle1"
                          align="left"
                          key={line}
                        >
                          {line}
                        </Typography>
                      </div>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </React.Fragment>
  );
}
